import 'moment-timezone';
import moment from "moment-timezone";
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { SplitButton } from 'primereact/splitbutton';
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AiOutlinePlus } from "react-icons/ai";
import { FaTrashAlt } from 'react-icons/fa';
import Moment from 'react-moment';
import { NumericFormat } from 'react-number-format';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { BadgeStatus, getEndpointUrl, getTimestamp } from "../../Utils/Common";
import ModalDeleteOffer from "./ModalDeleteOffer";
import ModalDeleteOfferMultiple from './ModalDeleteOfferMultiple';

const TableOffer = () => {
    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [query, setQuery] = useSearchParams();

    const navigate = useNavigate();

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const inputRef = useRef();
    const timeout = useRef();

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);

    const [selectAll, setSelectAll] = useState(false);
    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [customers, setCustomers] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 15,
        page: 0
    });

    const [toggledClearRows, setToggleClearRows] = useState(false);

    const [showDelete, setShowDelete] = useState(false);
    const [deleteData, setDeleteData] = useState({});

    const [showDeleteMultiple, setShowDeleteMultiple] = useState(false);

    const isSelectable = (data) => data.id != 0;

    const isRowSelectable = (event) => (event.data ? isSelectable(event.data) : true);

    const loadLazyData = (q) => {
        setLoading(true);

        fetch(getEndpointUrl() + `/offer?page=${lazyParams.page}&per_page=${lazyParams.rows}&query=${globalFilterValue}&v=${getTimestamp()}` +
            `&status=${(q.get('status') !== null) ? q.get('status') : ''}` +
            `&startDate=${(q.get('startDate') !== null) ? q.get('startDate') : ''}` +
            `&endDate=${(q.get('endDate') !== null) ? q.get('endDate') : ''}`,
            {
                headers: new Headers({
                    Authorization: `Bearer ${accesToken}`,
                    // pragma: 'no-cache',
                }),
            }).then(response => response.json()).then(json => {
                if (json.status === 'ok') {
                    setTotalRecords(json.results.total);
                    setCustomers(json.results.data);
                }
                setLoading(false);
            });
    }

    const onPage = (event) => {
        setLazyParams(event);
    }

    useEffect(() => {
        loadLazyData(query);
    }, [lazyParams]);

    useEffect(() => {
        loadLazyData(query)
    }, [query]);

    useEffect(() => {
        //Clear the previous timeout.
        clearTimeout(timeout.current);

        // If there is no search term, do not make API call
        if (!globalFilterValue.trim()) {
            loadLazyData(query);
            return;
        }
        timeout.current = setTimeout(() => {
            query.set('query', globalFilterValue);
            setQuery(query);
            loadLazyData(query);
        }, 1000);
    }, [globalFilterValue]);

    const onGlobalFilterChange = (e) => {
        setLoading(true);
        lazyParams.page = 0;
        setTotalRecords(0);
        setCustomers([]);

        const value = e.target.value;

        setGlobalFilterValue(value);
    };

    const onSelectionChange = (event) => {
        const value = event.value;
        setSelectedCustomers(value);
        setSelectAll(value.length === totalRecords);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        query.set('status', e.target.status.value);
        query.set('startDate', (e.target.startDate.value !== '') ? moment(e.target.startDate.value).format('YYYY-MM-DD') : '');
        query.set('endDate', (e.target.endDate.value !== '') ? moment(e.target.endDate.value).format('YYYY-MM-DD') : '');
        setQuery(query);
    };

    const resetFilter = (e) => {
        setGlobalFilterValue('');
        setStartDate('');
        setEndDate('');
        
        navigate('/penawaran');
    }

    const header = (
        <>
            <Row>
                <Col md={4} sm={12} className="my-2">
                    <h5 className="me-auto fw-bold pt-2">Data Penawaran</h5>
                </Col>
                <Col md={8} sm={12} className="my-2">
                    <div className="d-md-flex">
                        <div className="ms-auto">
                            {selectedCustomers?.length ?
                                <Button key="delete" onClick={(e) => {
                                    setShowDeleteMultiple(true);
                                    setToggleClearRows(!toggledClearRows);
                                }} variant="danger" className="me-3"><FaTrashAlt /> ({selectedCustomers.length}) Hapus yang terpilih</Button> : ''
                            }
                            <Link to={`/penawaran/create`} title="Input Penawaran" className="btn btn-success me-3"><AiOutlinePlus className="me-2" /> Input Penawaran</Link>
                        </div>
                    </div>
                </Col>
            </Row>
            <Form onSubmit={onSubmit}>
                <Row>
                    <Col md={3}>
                        <Form.Group>
                            <Form.Control type="text" name="query" ref={inputRef} value={globalFilterValue} onChange={onGlobalFilterChange} autoComplete="off" placeholder="Pencarian..." />
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Select name="status">
                            <option value="">- Semua Status -</option>
                            <option value="pending" selected={query.get('status') == 'pending'} >Pending</option>
                            <option value="draft" selected={query.get('status') == 'draft'}>Draft</option>
                            <option value="complete" selected={query.get('status') == 'complete'}>Complete</option>
                        </Form.Select>
                    </Col>
                    <Col md={2}>
                        <DatePicker
                            startDate={startDate}
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            autoComplete="off"
                            placeholderText="Mulai tanggal"
                            name="startDate"
                            customInput={<Form.Control />} />
                    </Col>
                    <Col md={2}>
                        <DatePicker
                            startDate={startDate}
                            minDate={startDate}
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            autoComplete="off"
                            placeholderText="Sampai tanggal"
                            name="endDate"
                            customInput={<Form.Control />} />
                    </Col>
                    <Col md={3}>
                        <Button type="submit">Filter Data</Button>
                        <Button type="button" variant="secondary" onClick={resetFilter} className="ms-2">Reset</Button>
                    </Col>
                </Row>
            </Form>
        </>
    );

    const statusTemplate = (row) => <BadgeStatus status={row.status} />;

    const tglTemplate = (row) => <Moment format="DD/MM/YYYY - HH:mm A">{row.createdAt}</Moment>;

    const targetTemplate = (row) => row.items?.length != 0 ? `${row.items?.length} unit` : `-`;

    const priceTemplate = (row) => <NumericFormat
        value={row.price}
        displayType={'text'}
        thousandSeparator={true}
        className="fw-medium"
        prefix={'Rp'}
        renderText={(value, props) => <span {...props}>{value}</span>} />;

    const kelolaBodyTemplate = (rowData) => {
        return <SplitButton size="small" label="Detil" icon="pi pi-eye"
            onClick={(e) => navigate(`/penawaran/detil/${rowData.id}`)}
            model={[
                {
                    label: 'Edit',
                    icon: 'pi pi-pencil',
                    disabled: userLogin.role != 'admin',
                    command: () => navigate(`/penawaran/update/${rowData.id}`)
                },
                {
                    label: 'Hapus',
                    icon: 'pi pi-trash',
                    disabled: userLogin.role != 'admin',
                    command: () => {
                        setShowDelete(true);
                        setDeleteData(rowData);
                    }
                }
            ]} severity="secondary" text />
    };

    const onCallback = useCallback((e) => {
        setSelectedCustomers([]);
        loadLazyData(query);
    }, []);

    return (
        <Container className="mt-3">
            <DataTable
                value={customers}
                lazy
                size="small"
                responsiveLayout="scroll"
                dataKey="id"
                header={header}
                globalFilterFields={['judul', 'deskripsi']}
                emptyMessage="Tidak ada data yang ditemukan."
                paginator
                first={lazyParams.first}
                rows={15}
                totalRecords={totalRecords}
                onPage={onPage}
                loading={loading}
                selection={selectedCustomers}
                onSelectionChange={onSelectionChange}
                selectAll={selectAll}>
                <Column selectionMode="multiple" />
                <Column field="id" header="ID" />
                <Column field="status" header="STATUS" body={statusTemplate} />
                <Column field="phone" header="TGL DIBUAT" body={tglTemplate} />
                <Column field="customerName" header="NAMA PELANGGAN" />
                <Column field="customerPhone" header="NO HANDPHONE" />
                <Column field="items" header="TARGET INSPEKSI" body={targetTemplate} />
                <Column field="price" header="HARGA" body={priceTemplate} />
                <Column header="KELOLA" body={kelolaBodyTemplate} />
            </DataTable>
            <ModalDeleteOffer row={deleteData} onCallback={(e) => onCallback(e)} show={showDelete} close={() => setShowDelete(false)} />
            <ModalDeleteOfferMultiple dataDelete={selectedCustomers} onCallback={(e) => onCallback(e)} show={showDeleteMultiple} close={() => setShowDeleteMultiple(false)} />
        </Container>
    );
}

export default TableOffer;
